import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';
import { SubscriptionFlow } from '../types/SubscriptionFlow';

export interface CreateRunFlowTaskParams {
  readonly scheduleId: string;
  readonly flowId: string;
  readonly runAllOutputs: boolean;
  readonly isRunAllIncremental: boolean;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
  readonly shouldEmailWhenDone: boolean;
  readonly subscriptionFlow?: SubscriptionFlow;
}

export class CreateRunFlowTaskRequest extends Request<CreateRunFlowTaskParams, IResult> {
  constructor(params: CreateRunFlowTaskParams) {
    super('createRunFlowTask', params);
  }
}
